import React from 'react';
import { HistoryDataRes } from '../../types/res';
import { Box, Stack } from '@mui/material';
import friend_unfinished from '../../assets/icons/friend_unfinished.gif';
import friend_beat from '../../assets/icons/friend_beat.gif';
import friend_new from '../../assets/icons/friend_newgame.gif';
import { parseLabelPerPlatform } from '../../utils/now-playing-utils';

interface MemoryCardItemProps {
  item: HistoryDataRes;
}

export const MemoryCardItem: React.FC<MemoryCardItemProps> = ({ item }) => {
  const { Date, milestone, title, platform } = item;

  const renderMilestone = (milestone: string) => {
    switch (milestone) {
      case 'Added':
        return friend_new;
      case 'New (Beat)':
        return friend_new;
      case 'Beat':
        return friend_beat;
      case 'Started':
        return friend_unfinished;
      default:
        return '';
    }
  };

  return (
    <Stack alignItems={'flex-start'} fontSize={'11px'} paddingBottom={1}>
      <div>
        <b>
          <u>{Date}</u>
        </b>
      </div>
      <Box textAlign={'left'}>
        <b>
          <img src={renderMilestone(milestone)} /> {milestone === 'Added' ? 'New' : milestone}:
        </b>{' '}
        {title} ({parseLabelPerPlatform(platform)})
      </Box>
    </Stack>
  );
};
